import React from 'react';
import MatchStatisticsScrollable from '../../MatchStatisticsScrollable';
import { WidgetWrapper } from '../../../sportradar-widgets/WidgetWrapper';
import { SrWidgetMatchCommentary } from '../../../sportradar-widgets/SrWidgetMatchCommentary';

function BetradarMTStatisticsCommentary({ matchId }) {
    return (
        <MatchStatisticsScrollable>
            <WidgetWrapper>
                <SrWidgetMatchCommentary matchId={matchId} />
            </WidgetWrapper>
        </MatchStatisticsScrollable>
    );
}

export default BetradarMTStatisticsCommentary;
